
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1920","height":"96","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".3","d":"M190.901 85.285C75.761 81.389 15.659 59.309.001 48.757V96H1920V2c-133.93 10.228-519.23 74.031-731.62 74.031-212.388 0-253.367-47.243-497.74-54.062-244.372-6.819-355.814 68.186-499.739 63.316z","fill":"#E5B409"}}),_c('path',{attrs:{"opacity":".3","d":"M117.47 43.534C55.886 31.982 13.497 38.721 0 43.534V96h1920V61.825c-204.61 2.567-638.83 4.813-738.81-6.739-124.96-14.44-284.423 0-418.888 8.664-134.465 8.664-217.444-12.996-359.407-35.137C260.932 6.47 194.449 57.974 117.47 43.534z","fill":"#E5B409"}}),_c('path',{attrs:{"opacity":".3","d":"M512.233 36.863C382.301 5.853 116.606-.618 0 .045V96h1920V20.464c-6.83-.994-45.28.597-144.42 14.909-123.94 17.89-629.18-23.854-773.6-26.339-144.427-2.484-327.331 66.591-489.747 27.83z","fill":"#E5B409"}}),_c('path',{attrs:{"d":"M479.5 60C311.9 56.8 88.833 83.5 0 96h1920s-165-25-337-25c-257 0-426 21.5-629.5 21.5S689 64 479.5 60z","fill":"#E5B409"}})])
          )
        }
      }
    